module.exports = __webpack_public_path__ + "static/media/glasschain-img-only.eaed2fa7.png";